import { z } from 'zod';
export const ODDS_PROVIDERS = ['Smarkets', 'SX Bet', 'Polymarket', 'Pinnacle', 'Bet365', 'API-Football'];
export const OUTCOMES = ['home', 'away', 'draw', 'over', 'under'];
export const SETTLEMENT_SCOPES = ['regular_time', 'full_time_incl_et'];
export const LIVE_PROVIDER_STATES = ['usable', 'blocked', 'stopped', 'finished', 'stale', 'provider_failed', 'rate_limited', 'invalid_payload'];
export const oddsProviderSchema = z.enum(ODDS_PROVIDERS);
export const outcomeSchema = z.enum(OUTCOMES);
export const settlementScopeSchema = z.enum(SETTLEMENT_SCOPES);
export const liveProviderStateSchema = z.enum(LIVE_PROVIDER_STATES);
export const observationSchema = z.object({
    eventId: z.string().trim().min(1),
    mappingId: z.string().trim().min(1),
    sourceObservationId: z.string().trim().min(1),
    provider: oddsProviderSchema,
    outcome: outcomeSchema,
    odds: z.number().positive().nullable(),
    oddsPhase: z.enum(['pre_match', 'live']).default('live'),
    providerState: liveProviderStateSchema.optional(),
    providerStatus: z.string().trim().min(1).optional(),
    providerTimestamp: z.number().int().positive().optional(),
    timestamp: z.number().int().positive(),
    clobTokenId: z.string().trim().min(1).optional(),
    settlementScope: settlementScopeSchema.optional(),
    gameMinute: z.number().int().min(0).max(180).optional(),
    fixtureScore: z.string().trim().min(1).optional(),
}).superRefine((observation, context) => {
    if (observation.odds === null
        && (observation.providerState === undefined || ['usable', 'stale'].includes(observation.providerState))) {
        context.addIssue({
            code: 'custom',
            path: ['odds'],
            message: 'Available source observations require a current numeric value',
        });
    }
});
export const batchObservationsSchema = z.array(observationSchema).min(1).max(500);
